import React from 'react';
import clsx from 'clsx';

import ModifyButton from 'components/atoms/Button/ModifyButton';

import './index.scss';

const SpConfOdItem = ({ text, children, modify, modifyLinks }) => {
    return (
        <div className="SpConfOdItem">
            <div className="tagArea">
                <label className="tag">{text}</label>
            </div>

            <div className="">
                <span className="items">
                    {children}
                </span>
                <span className={clsx('modify-button-area', { hide: modify === false })}>
                    <span className="">
                        <ModifyButton onClick={modifyLinks} />
                    </span>
                </span>
            </div>
        </div>
    );
};

export default SpConfOdItem;